import { Inject, Injectable, Injector } from '@angular/core';


import { SPSCommerce_create_order_with_validationService } from './SPSCommerce.flow.index';
import { SPSCommerce_get_completed_ordersService } from './SPSCommerce.flow.index';
import { SPSCommerce_get_order_with_optionsService } from './SPSCommerce.flow.index';

import { $frontendTypes } from './SPSCommerce.frontend.types'

@Injectable({ providedIn: 'root' })
export class SPSCommerce_FlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public SPSCommerce: SPSCommerce_FlowService = this;

  // injecting lazily in order to avoid circular dependencies
 
  private _create_order_with_validation: SPSCommerce_create_order_with_validationService;
  public async create_order_with_validation($inParams: { orders?: $frontendTypes.FootprintApiManager.DatexOrderInfo[] }): Promise< { messages?: any[], results?: { request_id?: string, order_id?: string, reference_code?: string, project?: string, warehouse?: string, message?: string, order?: any, entities?: any, transaction_id?: string }[], reasons?: string[] }> {
    if(!this._create_order_with_validation) { 
      this._create_order_with_validation = this.injector.get(SPSCommerce_create_order_with_validationService);
    }
    return this._create_order_with_validation.run($inParams);
  }
   
   

   
 
  private _get_completed_orders: SPSCommerce_get_completed_ordersService;
  public async get_completed_orders($inParams: { shipped_date: string, order_types?: string[], projects?: string[], has_transmission: boolean }): Promise< { messages?: any[], orders?: { order_id?: number, order_lookup?: string, order_status?: string, shipment_id?: number, project_id?: number, project_lookup?: string, shipped_date?: string, modified_date?: string, transaction_id?: string }[] }> {
    if(!this._get_completed_orders) { 
      this._get_completed_orders = this.injector.get(SPSCommerce_get_completed_ordersService);
    }
    return this._get_completed_orders.run($inParams);
  }
   
   

   
 
  private _get_order_with_options: SPSCommerce_get_order_with_optionsService;
  public async get_order_with_options($inParams: { transaction_id?: string, order_lookup?: string, project_lookup?: string, shipment_id?: number, set_transmission: boolean }): Promise< { orders?: $frontendTypes.FootprintApiManager.DatexOrderInfo[], messages?: any[], status?: string }> {
    if(!this._get_order_with_options) { 
      this._get_order_with_options = this.injector.get(SPSCommerce_get_order_with_optionsService);
    }
    return this._get_order_with_options.run($inParams);
  }
   
   

   
}
